import React, { useState, useEffect } from "react";
import request from "request";

import Modal from "Modal";
import Input from "Input";
import Button from "Button";

const MergeOrderView = ({ selectedTab, isMergeOrderActive, setIsMergeOrderActive, mergeAndSelect, clearAndSelect}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const clearModal = () => {
    setIsMergeOrderActive(false);
    setIsSubmitting(false);
  };

  const handleMergeAndSelect = () => {
    setIsSubmitting(true);
    mergeAndSelect(selectedTab);
    clearModal();
  };

  const handleClearAndSelect = () => {
    setIsSubmitting(true);
    clearAndSelect(selectedTab);
    clearModal();
  };



  const renderModalActions = () => {
    return (
      <div className="is-flex is-flex-grow-1">
        <Button
          onClick={clearModal}
          text="Cancel"
          className="is-outlined"
          color="red"
        />

        <Button
          text={`Add cart to Tab`}
          loading={isSubmitting}
          onClick={handleMergeAndSelect}
          color="green"
          className="is-text-weight-bold ml-auto"
        />

        <Button
          text={`Clear cart and select Tab`}
          loading={isSubmitting}
          onClick={handleClearAndSelect}
          color="green"
          className="is-text-weight-bold ml-auto"
        />
      </div>
    );
  };

  return (
    <div className="CustomerView">
      <Modal
        open={!!isMergeOrderActive}
        toggleModal={clearModal}
        actions={renderModalActions()}
      >
        <div>
          <h3 className="title">Select Tab</h3>
          <p> You selected Tab for <b style={{fontWeight: "bold"}}>{selectedTab.formattedCustomer}</b> <br/> while a different order is currently active in the cart.</p>
          <p> Do you want to add the cart to the tab for <b style={{fontWeight: "bold"}}>{selectedTab.formattedCustomer}</b> <br/> or clear the cart and select the tab?</p>
        </div>
      </Modal>
    </div>
  );
};

export default MergeOrderView;
